import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TransportMode, NOT_AVAILABLE, SCode, UNKNOWN } from '../../common/constants';
import { LoadStatus } from '../../store/state/shipment-load/models';
import { LoadSecondary } from '../../store/state/monitoring/transport/models';
import { TransportOrderLoad } from '../../store/state/shipment-transport-order/models';
import { DeviationType, MonitoringPageType, StatusAcceptanceType } from '../../store';

@Component({
  selector: 'ui-load-info-bar',
  templateUrl: './load-info-bar.component.html',
  styleUrls: ['./load-info-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadInfoBarComponent {
  @Input() load: TransportOrderLoad | LoadSecondary;
  @Input() loadStatus: LoadStatus;
  @Input() monitoringPageType?: MonitoringPageType;
  @Input() transportOrderNumber?: string;
  @Input() internalMaterialId?: string;
  @Input() internalPlantId?: string;

  transportMode = TransportMode;
  notAvailable = NOT_AVAILABLE;
  sCode = SCode;
  unknown = UNKNOWN;
  loadStatusAcceptanceType = StatusAcceptanceType;
  deviationType = DeviationType;
}
